__turbopack_context__.v({
  "buttonGroup": "BCVlkq_buttonGroup",
  "partnerPageFooter": "BCVlkq_partnerPageFooter",
  "title": "BCVlkq_title",
});
